function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 6.66667H9.33333C8.97971 6.66667 8.64057 6.52619 8.39052 6.27614C8.14048 6.02609 8 5.68696 8 5.33333V1.33333C8 0.979711 8.14048 0.640573 8.39052 0.390524C8.64057 0.140476 8.97971 0 9.33333 0L14.6667 0C15.0203 0 15.3594 0.140476 15.6095 0.390524C15.8595 0.640573 16 0.979711 16 1.33333V5.33333C16 5.68696 15.8595 6.02609 15.6095 6.27614C15.3594 6.52619 15.0203 6.66667 14.6667 6.66667H12.6667L10 8.66667V6.66667Z",
  fill: "#002A95"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 14.6667H0.666667C0.489856 14.6667 0.320286 14.5964 0.195262 14.4714C0.0702379 14.3464 0 14.1768 0 14V3.33332C0 3.15651 0.0702379 2.98694 0.195262 2.86192C0.320286 2.73689 0.489856 2.66666 0.666667 2.66666H6.66667V3.99999H1.33333V13.3333H13.3333V7.99999H14.6667V14C14.6667 14.1768 14.5964 14.3464 14.4714 14.4714C14.3464 14.5964 14.1768 14.6667 14 14.6667Z",
  fill: "#002A95"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33333 8.66667C6.06971 8.66667 6.66667 8.06971 6.66667 7.33333C6.66667 6.59695 6.06971 6 5.33333 6C4.59695 6 4 6.59695 4 7.33333C4 8.06971 4.59695 8.66667 5.33333 8.66667Z",
  fill: "#002A95"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33317 9.33334C6.04041 9.33334 6.71869 9.61429 7.21879 10.1144C7.71889 10.6145 7.99984 11.2928 7.99984 12H2.6665C2.6665 11.2928 2.94746 10.6145 3.44755 10.1144C3.94765 9.61429 4.62593 9.33334 5.33317 9.33334Z",
  fill: "#002A95"
});

var SvgTickets = function SvgTickets(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTickets, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tickets.7a0949fc.svg";
export { ForwardRef as ReactComponent };